import { ZAttrLabelsData } from "src/common/attributes/makeAttrLabel/types/ZAttrLabelsData";
import { ZAttribute } from "src/types/ZAttribute";
import { ZRestriction } from "src/types/ZRestriction";
import { ZUid } from "src/types/zUid";

export interface BuilderCtx {
  typesMap: Record<number, string>;
  canUpdate:
    | boolean
    | ((attr: ZAttribute, typesMap: Record<number, string>) => boolean);
  stateId?: ZUid | null;
  objectName?: string;
  objectId: ZUid;
  entityId?: ZUid;
  labelsData?: ZAttrLabelsData;
  restrictValues?: boolean;
  /**
   * Регистрация загруженных ограничений по значению справочника.
   * Если задана, каскадной очисткой зависимых значений владеет внешний стор
   * (EntityCardStore.resetDependentAttrs), а не сам компонент. LPLM-5173
   */
  registerRestriction?: (attrId: ZUid, restriction: ZRestriction) => void;
}

export const canUpdateAttr = (ctx: BuilderCtx, attr: ZAttribute): boolean => {
  const { canUpdate, typesMap } = ctx;
  if (typeof canUpdate === "function") {
    return canUpdate(attr, typesMap);
  }
  return canUpdate;
};
